import React, { FC } from "react"
import styled from "@emotion/styled"
import Box from "@/components/Box"

const StyledLeftBackground = styled(Box)`
  width: 100%;
  height: 482px;
  background-position: right center;
  background-repeat: repeat-y;
  background-size: cover;
  background-image: url(${process.env
    .ASSETS_BASE_URL}/careers-page/middle-background-1.webp);
  background-color: #040e18;
  @media screen and (min-width: 1024px) {
    height: 516px;
    background-position: right center;
  }
`

const StyledRightBackground = styled(Box)`
  width: 100%;
  height: 482px;
  background-position: right center;
  background-repeat: repeat-y;
  background-size: cover;
  background-image: url(${process.env
    .ASSETS_BASE_URL}/careers-page/middle-background-2.webp);
  background-color: #040e18;
  @media screen and (min-width: 1024px) {
    height: 516px;
    background-position: right center;
  }
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1024px) {
    flex-direction: row;
  }
`

const BackgroundSection: FC = () => {
  return (
    <Wrapper>
      <StyledLeftBackground as="section" />
      <StyledRightBackground as="section" />
    </Wrapper>
  )
}

export default BackgroundSection
